import routerOptions0 from "/builds/brighterly/apps/land-app/node_modules/.pnpm/nuxt@3.16.1_@parcel+watcher@2.5.1_@types+node@22.14.0_db0@0.3.1_eslint@9.23.0_jiti@2.4._507235127e332d160c7c6d24e5496438/node_modules/nuxt/dist/pages/runtime/router.options.js";
import routerOptions1 from "/builds/brighterly/apps/land-app/app/router.options.ts";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = routerOptions0.hashMode ?? false
export default {
...configRouterOptions,
...routerOptions0,
...routerOptions1,
}